module.exports = __webpack_public_path__ + "img/bannerMobile.581ecdb8.svg";